import { DEFAULT_LANGUAGE_TYPE } from '@wilson/localization/constants';

export function numberFormatter(
  locales: string | string[] = DEFAULT_LANGUAGE_TYPE,
  options: Intl.NumberFormatOptions = {},
) {
  const resolvedOptions: Intl.NumberFormatOptions = {
    // Default to 0-2 fraction digits
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    // Optional overrides
    ...options,
  };
  const intlFormatter = createIntlNumberFormat(locales, resolvedOptions);

  return (value: number): string => {
    if (isNaN(value)) {
      return '';
    }

    return intlFormatter.format(value);
  };
}

function createIntlNumberFormat(
  locales: string | string[],
  options: Intl.NumberFormatOptions,
): Intl.NumberFormat {
  try {
    return new Intl.NumberFormat(locales || DEFAULT_LANGUAGE_TYPE, options);
  } catch (error) {
    // Invalid locale tags (e.g. the dev-only 'show-translation-key' language)
    // throw a RangeError. Fall back instead of breaking the whole template.
    // Invalid options still throw, as the retry uses the same options.
    if (error instanceof RangeError) {
      return new Intl.NumberFormat(DEFAULT_LANGUAGE_TYPE, options);
    }
    throw error;
  }
}
